import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '最新资讯', to: '/news' },
  { label: '角色攻略', to: '/characters' },
  { label: '版本更新', to: '/updates' },
  { label: '首页', to: '/' },
];

const helpfulLinks = [
  { label: '深境螺旋攻略', to: '/detail/news-abyss-12' },
  { label: '海灯节活动', to: '/detail/news-lantern-2026' },
  { label: '钟离攻略', to: '/detail/guide-zhongli' },
  { label: '胡桃攻略', to: '/detail/guide-hutao' },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-gamepad-line text-lg"></i>
              </span>
              <span className="font-display text-lg font-bold text-foreground-950">原神情报站</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              原神情报站是一个专注于《原神》的资讯与攻略内容平台，为旅行者提供最新的游戏新闻、版本动态、角色解读与玩法技巧，帮助你更深入地理解提瓦特大陆的每一处细节。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-youtube-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-500 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">快捷导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900">热门内容</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {helpfulLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 原神情报站 · 本站为游戏资讯与攻略演示平台，内容仅供学习交流。
          </p>
          <p className="text-xs text-foreground-500">
            《原神》相关名称与角色版权归米哈游所有 · 本站与官方无从属关系
          </p>
        </div>
      </div>
    </footer>
  );
}